
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M3.004 4h-1v16H22v-1l.003-14V4h-19zm1 3.208V18h15.998l.002-10.789-7.422 5.177-.572.399-.572-.399-7.434-5.18zM18.244 6H5.768l6.241 4.349L18.244 6z"}})])
          )
        }
      }
    